import * as BABYLON from 'babylonjs';
import BasicComponent from './BasicComponent';
import MaterialManager from "@/components/babylonjs/Materials";

class NotifyPosition extends BasicComponent {
    getType() { return "NotifyPosition"; }

    constructor( { id } = {} ) {
        super( { id });

        this.event = null;
        this.material = null;
        this.texture = null;
        this.mesh = null;
        this.scene = null;
        this.scaleFactor = 1;        
    }

    construct( context, event ) {
        this.scene = window.scene;
        this.event = event;
        this.setID( event.getID() );

        const base = new BABYLON.TransformNode(event.getID(), window.scene);
        this.setRootNode(base);
    
        if (event.getPosition()) {
          base.position = BABYLON.Vector3.Lerp( event.getPosition(), this.scene.activeCamera.position, 0.1 );
        } else {
          base.position = base.absolutePosition;
          event.setPosition(event.position);
        }
        if( event.getRotation()) {
            base.rotation = event.getRotation();
        }
    
        const name = "Event_" + event.getID();

        
        this.mesh = BABYLON.MeshBuilder.CreatePlane(name,
          {
            width: 15,
            height: 15,
            sideOrientation: BABYLON.Mesh.DOUBLESIDE
          }, window.scene);

        this.mesh.isPickable = false; // Disable picking, otherwise we could click on Notifications... Gives nice effect but unintended
          
        //this.mesh = BABYLON.MeshBuilder.CreateSphere("sphere", {diameter: 10, diameterX: 10}, this.scene);
        //this.mesh.rotate(BABYLON.Axis.X, Math.PI / 2, BABYLON.Space.LOCAL );

        base.rotation = BABYLON.Vector3.Zero(); //rotation;
        base.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;

        this.material = MaterialManager.get("info");
        this.mesh.material = this.material;
        this.mesh.parent = base;

        let audio = new Audio(require('@/assets/sounds/ripple.mp3'));
        audio.play();

        return this;
    }
}

export default NotifyPosition;
